import React, { useEffect, useState } from "react";
import CustomLoader from "../../CustomComponents/loader/CustomLoader";
import HttpClient from "../../utils/HttpClient";
import toast from "react-hot-toast";
import DataTable from "react-data-table-component";
import EditDeleteIcon from "../../CustomComponents/EditDeleteIcon";
import moment from "moment";
import { DeleteConfirmModal } from "../../CustomComponents/DeleteConfirmModal";
import { ImCross } from "react-icons/im";
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "35px",
  fontWeight: "bold",
};
const customStyles = {
  rows: {
    style: {
      minHeight: "24px", // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: "18px", // override the cell padding for head cells
      paddingRight: "8px",
      backgroundColor: "#cee0eb", // set the background color for head cells
    },
  },
};

const PromoCode = () => {
  const [subscription, setSubscription] = useState("");
  const [selectedSubscription, setSelectedSubscription] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [validFrom, setValidFrom] = useState();
  const [validTo, setValidTo] = useState();


  const [subscriptionList, setSubscriptionList] = useState([]);

  const [ServicesID, setServicesID] = useState("");
  const [AllData, setAllData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isEdit, setisEdit] = useState(false);
  const [editID, setEditID] = useState();


  const resetFormData = () => {
    setSelectedSubscription("");
    setPromoCode("");
    setPercentage(0)
    setValidFrom("")
    setValidTo("")
  }

  //Add type
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSubscription) {
      return toast.error("Choose subscription.")
    }
    if (!promoCode) {
      return toast.error("Enter code.")
    }
    if (percentage < 1 || percentage > 100) {
      return toast.error("Enter a valid percentage")
    }
    if (!validFrom) {
      return toast.error("Choose from date.")
    }
    if (!validTo) {
      return toast.error("Choose to date.")
    }

    setisLoading(true);
    const data = {
      subscriptionId: selectedSubscription,
      promoCode: promoCode,
      percentage: parseInt(percentage),
      validFrom: moment(validFrom).format("YYYY-MM-DD"),
      validTo: moment(validTo).format("YYYY-MM-DD")
    };
    // return
    const res = await HttpClient.requestData("promocode", "POST", data);
    // if (promoCode !== "" && subscription !== "") {
    if (res && res?.status) {
      setisLoading(false);
      resetFormData()
      toast.success("Promo Code added successfully!");
      getPromoCodes();
    } else {
      setisLoading(false);
      toast.error("Error occured!");
    }
    // } else {
    //   setisLoading(false);

    //   toast.error("Field cant empty");
    // }
  };

  const columns = [
    {
      name: "SL",
      selector: (row) => row.sl,
      width: "5%",
    },
    {
      name: "Subscription",
      selector: (row) => row.Subscription,
      width: "20%",
      wrap: true,
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      width: "25%",
    },
    {
      name: "Percentage",
      selector: (row) => row.Discount,
      width: "10%",
    },
    {
      name: "Valid From",
      selector: (row) => row.ValidFrom,
      width: "15%",
    },
    {
      name: "Valid To",
      selector: (row) => row.ValidTo,
      width: "15%",
    },
    {
      name: "Action",
      selector: (row) => row.action,
      width: "10%",
    },
  ];

  // Get Subscriptions
  const getSubscriptions = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData("subscription", "GET", {});
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      setSubscriptionList(res?.data);
    } else {
      setisLoading(false);
    }

    // setAllData(apiData);
  };
  // get servicec
  const getServices = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData(
      "subscription/" + selectedSubscription,
      "GET",
      {}
    );
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      apiData = res?.data?.map((item, i) => ({
        sl: i + 1,
        name: item?.name,
        createdOn: moment(item?.createdOn).format("DD-MM-YYYY"),

        action: (
          <EditDeleteIcon
            onClickEdit={(e) => handleEdit(item)}
            onClickDelete={(e) => handleDelete(item?._id)}
          />
        ),
      }));
    } else {
      setisLoading(false);
    }

    setAllData(apiData);
  };

  // get servicec
  const getPromoCodes = async () => {
    setisLoading(true);
    const res = await HttpClient.requestData(
      "promocode",
      "GET",
      {}
    );
    let apiData = [];
    if (res && res?.status) {
      setisLoading(false);
      apiData = res?.data?.map((item, i) => ({
        sl: i + 1,
        Subscription: item?.Subscription?.plan,
        Code: item?.promoCode,
        Discount: item?.percentage,
        ValidFrom: moment(item?.validFrom).format("DD-MM-YYYY"),
        ValidTo: moment(item?.validTo).format("DD-MM-YYYY"),

        action: (
          <EditDeleteIcon
            onClickEdit={(e) => handleEdit(item)}
            onClickDelete={(e) => handleDelete(item?._id)}
          />
        ),
      }));
    } else {
      setisLoading(false);
    }

    setAllData(apiData);
  };
  //Delete part
  const handleDelete = (id) => {
    const del = async () => {
      setisLoading(true);
      const res = await HttpClient.requestData(
        "promocode/" + id,
        "DELETE"
      );
      if (res && res?.status) {
        setisLoading(false);
        toast.success("Deleted Successfully!");
        getPromoCodes();
      } else {
        setisLoading(false);
        toast.error(res?.message || "Error occured!");
      }
    };

    DeleteConfirmModal(del);
  };
  //Edit
  const handleEdit = async (item) => {
    // console.log(item?.validFrom, "LINE246");
    setisEdit(true);
    setEditID(item?._id)
    setSelectedSubscription(item?.subscriptionId)
    setPromoCode(item?.promoCode)
    setPercentage(item?.percentage)
    setValidFrom(moment(item?.validFrom).format("YYYY-MM-DD"))
    setValidTo(moment(item?.validTo).format("YYYY-MM-DD"))
    // setSubscription(item?.companyTypeID);
    // setServicesID(item?._id);
    // setPromoCode(item?.name);
  };
  //cancel edit
  const cancelEdit = (e) => {
    setisEdit(false);
    resetFormData()
    // setPromoCode("");
    // setServicesID("");
  };
  // edit submit
  const handleEditSubmit = async (e) => {
    // console.log("valuesdd");
    e.preventDefault();
    if (!selectedSubscription) {
      return toast.error("Choose subscription.")
    }
    if (!promoCode) {
      return toast.error("Enter code.")
    }
    if (percentage < 1 || percentage > 100) {
      return toast.error("Enter a valid percentage")
    }
    if (!validFrom) {
      return toast.error("Choose from date.")
    }
    if (!validTo) {
      return toast.error("Choose to date.")
    }
    
    setisLoading(true);
    const data = {
      subscriptionId: selectedSubscription,
      promoCode: promoCode,
      percentage: parseInt(percentage),
      validFrom: moment(validFrom).format("YYYY-MM-DD"),
      validTo: moment(validTo).format("YYYY-MM-DD")
    };

    const res = await HttpClient.requestData(
      "promocode/" + editID,
      "PUT",
      data
    );
    // console.log("resCat", res)
    if (res && res?.status) {
      setisEdit(false);
      setEditID("")
      resetFormData()
      // setPromoCode("");
      // setSubscription("");
      setisLoading(false);
      toast.success("Updated Successfully!");
      getPromoCodes();
    } else {
      setisLoading(false);
      toast.error(res?.message || "Error occured!");
    }
  };

  useEffect(() => {
    getSubscriptions();
  }, []);

  useEffect(() => {
    getPromoCodes();
  }, [selectedSubscription]);

  return (
    <div>
      <CustomLoader loading={isLoading} />

      <div className="d-flex justify-content-end">
        <div className="form-header">
          <section className="piechartsBox_area">
            <div style={headLineStyle} className="page-headline">
              Promo Code
            </div>
            <form>
              <div className="row">

                <div className="col-md-3 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Subscription<span className="text-danger">&nbsp;*</span>
                  </label>
                  <select
                    type="text"
                    className="form-control"
                    placeholder="subscription Name Name"
                    name=""
                    value={selectedSubscription}
                    onChange={(e) => setSelectedSubscription(e.target.value)}
                  >
                    <option value="" disabled>
                      --- Choose ---
                    </option>
                    {subscriptionList?.map((item, i) => {
                      return (
                        <>
                          <option value={item?._id}>{item?.plan}</option>
                        </>
                      );
                    })}
                  </select>
                </div>

                <div className="col-md-3 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Promo Code<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter code"
                    name=""
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                  />
                </div>

                <div className="col-md-2 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Percentage<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter %value"
                    name=""
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value)}
                  />
                </div>

                <div className="col-md-2 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Valid From<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Enter %value"
                    name=""
                    value={validFrom}
                    onChange={(e) => setValidFrom(e.target.value)}
                  />
                </div>

                <div className="col-md-2 mt-3 ">
                  <label htmlFor="formGroupExampleInput">
                    Valid To<span className="text-danger">&nbsp;*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Enter %value"
                    name=""
                    value={validTo}
                    onChange={(e) => setValidTo(e.target.value)}
                  />
                </div>

              </div>

              {/* Button */}
              <div className="col-12 d-flex justify-content-end ">
                {isEdit ? (
                  <div className=" d-flex ">
                    <button
                      type="submit"
                      onClick={(e) => handleEditSubmit(e)}
                      className="btn btn-primaryb mt-3 btn-grad"
                    // style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                    >
                      Update Data
                    </button>
                    <ImCross
                      onClick={(e) => cancelEdit(e)}
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      className=" mx-3 mt-4 text-danger "
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={(e) => handleSubmit(e)}
                    className="btn btn-primaryb mt-3"
                    style={{
                      background:
                        "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))",
                      color: "#fff",
                    }}
                  >
                    Add Data
                  </button>
                )}
              </div>
            </form>
            <div className="mt-2">
              <div style={headLineStyle} className="page-headline">
                Promo Code(s)
              </div>
              {/* <div className="col-md-6 mt-2 ">
                <label htmlFor="formGroupExampleInput">
                  Subscription
                  <span className="text-danger">&nbsp;*</span>
                </label>
                <select
                  type="text"
                  className="form-control"
                  placeholder="subscription Name Name"
                  name=""
                  value={selectedSubscription}
                  onChange={(e) => setSelectedSubscription(e.target.value)}
                >
                  <option value="" disabled>
                    Select
                  </option>
                  {subscriptionList?.map((item, i) => {
                    return (
                      <>
                        <option value={item?._id}>{item?.plan}</option>
                      </>
                    );
                  })}
                </select>
              </div> */}
              <DataTable
                columns={columns}
                data={AllData}
                pagination
                striped
                className=" rounded mt-1"
                customStyles={customStyles}
              />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PromoCode;
